import { CommonModule } from '@angular/common';
import { Component, OnInit, ChangeDetectionStrategy, Input } from '@angular/core';

@Component({
  standalone: true,
  selector: 'img-profile',
  imports: [CommonModule],
  templateUrl: './img-profile.atom.html',
  styles: [
    `
      :host {
        display: block;
      }
      .w-104 {
        width: 26rem;
      }
      .h-128 {
        height: 32rem;
      }
    `,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class imgProfileAtom implements OnInit {
  @Input() imgSrc = '/frontend-assets/images/bigImg.webp';

  @Input() isSize = 'big';

  constructor() { }

  ngOnInit(): void { }
}
